<template>
    <Dialog header="created " v-model:visible="visible" :closable="false"
        :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }" :style="{ width: '30vw' }" :modal="true">

        <img class="success" src="../../assets/Gif/alreadyexist.gif">
        <p class="msg">{{ selectedcontent }} {{ content }}</p>
        <template #header>
            <b-container fluid>
                <b-row>
                    <b-col class="d-flex flex-row-reverse">
                        <i class="pi pi-times" @click="$emit('Ok')" />
                    </b-col>
                </b-row>
            </b-container>

        </template>
    </Dialog>
</template>

<script lang="ts">

import { defineComponent, ref } from 'vue'
export default defineComponent({

    props: {

        visible: {
            readonly: false,
            type: Boolean,
            default: ref(false),

        },
        content: {
            type: String,
            required: true
        },
        selectedcontent: {
            type: String,
            default: "Selected Item Already Mapped with"
        }

    },
    setup() {

        return {

        }
    },
    methods: {
    }
})

</script>
<style lang="scss" scoped>
.success {
    width: 208px;
}
</style>